import { useState, useRef, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import "../../assets/css/searchmenu.css";
import { getProductUrl } from "../../utils/url.utils";

function ViewAll({ data = [] }) {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const scrollPosition = useRef(0);

  const handleShow = () => {
    scrollPosition.current = window.scrollY;
    setShow(true);
  };

  const handleClose = () => {
    const y = scrollPosition.current;
    setShow(false);
    requestAnimationFrame(() => {
      window.scrollTo(0, y);
    });
  };

  // Search Filter
  const filteredData = useMemo(() => {
    if (!search.trim()) return data;

    return data.filter((item) =>
      item.quality_name
        ?.toLowerCase()
        .includes(search.toLowerCase())
    );
  }, [data, search]);

  const columns = 6;
  const perColumn = Math.ceil(filteredData.length / columns);

  return (
    <>
      <Link
        onClick={handleShow}
        style={{
          color: "#ee0d0d",
          fontSize: "12px",
          paddingRight: "38px",
          cursor: "pointer",
          textDecoration: "underline"
        }}
      >
        View More ...
      </Link>

      <Modal
        show={show}
        onHide={handleClose}
        fullscreen
        backdrop="static"
        keyboard={false}
        animation={false}
        restoreFocus={false}
        enforceFocus={false}
        scrollable
        className="modal-search"
      >
        <Modal.Header
          style={{
            border: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="search-menu" style={{ flexGrow: 1 }}>
            <i className="bi bi-search search-icon"></i>

            <input
              type="search"
              className="form-control"
              placeholder="Search Quality..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <Button
            variant="link"
            onClick={handleClose}
            className="btnclose"
            style={{
              color: "gray",
              background: "#FFF",
              textDecoration: "none",
            }}
          >
            <i className="bi bi-x-lg" style={{ fontSize: "18px" }}></i>
          </Button>
        </Modal.Header>

        <Modal.Body>
          {filteredData.length === 0 ? (
            <div className="text-center py-5">
              <h5>No Data Found</h5>
            </div>
          ) : (
            <div className="row">
              {Array.from({ length: columns }).map((_, index) => (
                <div className="col-md-2" key={index}>
                  <ul className="nevcolor">
                    {filteredData
                      .slice(
                        index * perColumn,
                        (index + 1) * perColumn
                      )
                      .map((item, itemIndex) => (
                        <li
                          key={`${item.quality_action_link}-${itemIndex}`}
                        >
                          <Link
                            className="nevcolor"
                            to={getProductUrl(
                              item.quality_action_link
                            )}
                            onClick={handleClose}
                          >
                            {item.quality_name}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
export default ViewAll;